// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { PathCondition } from '@alme/ui-web/settings/settings';
import { languageSpecificSettingOverrides } from './language-specific-setting-override';

import { languageConstants } from './language-constants';

const defaultLanguageCode = languageConstants.languages[languageConstants.default];
const secureCookie = process.env.alme_api_protocol === 'https://' ? true : false;

export interface AlmeSettings {
    ClientSessionInactivityMs: number;
    ClientSessionTimeout: number;
    ClientSessionTimeoutWarning: number;
}


export default {
    //temp values for testing
    Alme: {
        ClientSessionInactivityMs: 5000,
        ClientSessionTimeout: 15,
        ClientSessionTimeoutWarning: 2,
    } as AlmeSettings,
    Cookies: {
        NITAlme: {
            getOptions: {

            },
            setOptions: {
                secure: secureCookie,
            },
        },
        NITAlmeUser: {
            getOptions: {

            },
            setOptions: {
                expires: 360,
                secure: secureCookie,
            },
        },
        NITOfferData: {
            getOptions: {

            },
            setOptions: {
                secure: secureCookie,
            },
        },
    },
    appeventConstants: {
        advocacyProactiveMessageName: "ProactiveMessage",
        outputMaskingEventName: "UDPVariableRetrievalFailure",
        getConversationTranscriptResponse: "GetConversationTranscriptResponse",
        errorEventName: "GenericErrorMessage",
        revokeSimplifiedAnnualEnrollmentEligibility: "SimplifiedAeRevokeEligibility",
        simplifiedAeFlowProcessUpdate: "SimplifiedAeFlowProcessUpdate",
    },
    deferredAppcallConstants: {
        availabilityAppCallName: "CheckChatAvailability",
    },
    endChatWarning: {
        ignoreBundledDisabler: false,
        isWarningEnabled: true,
    },

    endSession: {
        ignoreMessageSource: [
            "LiveChatGetNotification",
        ],
        notificationMessage: languageSpecificSettingOverrides[defaultLanguageCode]["endSession.notificationMessage"],
    },
    inputBox: {
        maxLength: 250,
    },
    InputBoxLock: {
        suppressWhen: [
            {
                statePath: "LiveChat.SessionState",
                operator: "notEqual",
                value: "Offline",
            },
        ],
    },
    time: {
        offsetParamName: "ClientTimeZoneOffset",
    },
    notificationsApi: {
        pollIntervalMS: 1000,
        pollStartActions: ['StartPollNotifications'],
        pollStopActions: ['StopPollNotifications'],
    },
    stepOutIcon: {
        ivaDomains: ["alight.com"],
        iconSvg: '<sup><svg class="step-out-header-link" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" focusable="false" height="12px" width="12px">' +
            `<title>${languageSpecificSettingOverrides[defaultLanguageCode]["accessibility.StepOutTitle"]}</title><g>` +
            '<path d="m397 512l-360 0c-21 0-37-17-37-37l0-361c0-20 16-37 37-37l119 0c20 0 36 17 36 37 0 20-16 37-36 37l-82 0 0 287 287 0 0-82c0-20 16-36 36-36 21 0 37 16 37 36l0 119c0 20-16 37-37 37z m78-259c-20 0-37-16-37-36l0-143-142 0c-20 0-36-17-36-37 0-20 16-37 36-37l179 0c20 0 37 17 37 37l0 180c0 20-16 36-37 36z m-178 5c-9 0-18-4-25-11-15-14-15-37-1-51l177-184c14-14 37-15 52-1 15 15 15 38 1 52l-177 184c-8 7-17 11-27 11z">' +
            '</path></g></svg></sup>',
    },
    launchPoint: {
        rightMargin: 0,
    },
    userLoggedIn: {
        loggedInFunctionName: "userLoggedIn",
        enableIVAfunctionName: "enableIVA2Features",
    },
    advocacySettings: {
        advocacyDataFunctionName: "advocacyProactiveLaunch",
        eligiblePageListName: "eligiblePageList",
    },
    SessionFromQs: {
        queryStringParamName: "sid",
    },
    uiVersionNumberParam: "UiVersionNumber",
    allowLinkSectionHeaderText: false,
    channelConstants: {
        channels: {
            Web: "Web",
            MobileWeb: "MobileWeb",
            MobileApp: "MobileApp",
        },
        default: "Web",
    },
    welcomeUser: {
        suppressWithLaunchQuestion: true,
        allowActivePonClicks: true,
    },
    History: {
        appendDelay: 900,
    },
    SmoothScroll: {
        On: true,
    },
    launchQuestionReportingEvent: {
        enabled: true,
    },
    enableLessFeature: {
        enabled: true,
    },
    processPostMessageAccessKey: {
        enabled: false,
    },
    enableFeedbackModalSubmitBeforeCancelButtonOrder: {
        enabled: false,
    },
    footerCounterSettings:{
        hidden:true,
    },
    EnableInputBoxForTheseAccessKeys:['5fc030d4-a143-4db5-b60b-7701b4f7d001'],
    escapeOpenCloseTags: true,
    disableIVAStateChange: true,
    maxHypeOffers: 3,
    configurationType:["linkId", "advAssetGrp", "qscEvent"]
};



// WEBPACK FOOTER //
// ./settings/settings.ts